module.exports = __webpack_public_path__ + "static/media/beefyfinance_night.a2b01833.png";